import clsx from 'clsx';
import type { JSX } from 'react';
import type { AvailabilitiesViewToggleContent } from '@/lib/types/siteSettings';

export type AvailabilitiesViewMode = 'cards' | 'map';

export function AvailabilitiesViewToggle({
  value,
  onChange,
  labels,
  className,
}: {
  value: AvailabilitiesViewMode;
  onChange: (next: AvailabilitiesViewMode) => void;
  labels?: AvailabilitiesViewToggleContent;
  className?: string;
}): JSX.Element {
  const titleLabel = labels?.label?.trim().length ? labels.label : 'View';
  const cardsLabel = labels?.cardsLabel?.trim().length ? labels.cardsLabel : 'Cards';
  const mapLabel = labels?.mapLabel?.trim().length ? labels.mapLabel : 'Map + list';

  return (
    <div className={clsx('flex items-center justify-between gap-3', className)}>
      <div>
        <p className="text-sm font-semibold text-brand-primary">{titleLabel}</p>
        <p className="text-xs text-text-primary/60">{value === 'map' ? mapLabel : cardsLabel}</p>
      </div>

      <div
        role="group"
        aria-label="Availability view"
        className="flex min-h-11 items-center rounded-2xl border border-surface-subtle bg-white p-1 shadow-sm"
      >
        <button
          type="button"
          aria-pressed={value === 'cards'}
          onClick={() => {
            onChange('cards');
          }}
          className={clsx(
            'min-h-11 rounded-xl px-4 text-xs font-semibold uppercase tracking-wide transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent',
            value === 'cards'
              ? 'bg-brand-primary text-white shadow-sm'
              : 'text-brand-primary hover:bg-brand-primary/5',
          )}
        >
          {cardsLabel}
        </button>
        <button
          type="button"
          aria-pressed={value === 'map'}
          onClick={() => {
            onChange('map');
          }}
          className={clsx(
            'min-h-11 rounded-xl px-4 text-xs font-semibold uppercase tracking-wide transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent',
            value === 'map'
              ? 'bg-brand-primary text-white shadow-sm'
              : 'text-brand-primary hover:bg-brand-primary/5',
          )}
        >
          {mapLabel}
        </button>
      </div>
    </div>
  );
}
